import CandidateInfoLayoutView from './candidate-info-management-layout';

function LayoutView() {
  return (
    <div className="container overflow-hidden bg-white h-100">
      <CandidateInfoLayoutView />
    </div>
  );
}

export default LayoutView;
